module.exports = __webpack_public_path__ + "img/bmgj-tab-pc.ea0f8074.svg";